const t = {
  content: "",
  group: "block",
  marks: "",
  atom: !0,
  attrs: {
    type: { default: "facebookLikeButton" },
    url: { default: "" }
  },
  toDOM() {
    return ["div"];
  }
};
export {
  t as facebookLikeButtonSpec
};
